import { ContentsTitle } from '../../featurestore/models';
import { CloudDiscoveryKey } from '../../utils/contexts';
import { AccessControl as FeaturestoreAccessControl } from '../Featurestore/AccessControl/AccessControl';
import { Dashboard as FeaturestoreDashboard } from '../Featurestore/Dashboard/Dashboard';
import { Feature as FeaturestoreFeature } from '../Featurestore/Feature/Feature';
import { FeatureSetDetails as FeaturestoreFeatureSetDetails } from '../Featurestore/FeatureSetDetails/FeatureSetDetails';
import { FeatureSets as FeaturestoreFeatureSets } from '../Featurestore/FeatureSets/FeatureSets';
import { Jobs as FeaturestoreJobs } from '../Featurestore/Jobs/Jobs';
import { PendingReviews as FeaturestorePendingReviews } from '../Featurestore/PendingReviews/PendingReviews';
import { ProjectDetails as FeaturestoreProjectDetails } from '../Featurestore/ProjectDetails/ProjectDetails';
import { Projects as FeaturestoreProjects } from '../Featurestore/Projects/Projects';
import { SearchResults as FeaturestoreSearchResults } from '../Featurestore/SearchResults/SearchResults';
import { RoutePaths } from '../RoutePaths';
import type { RouteDefinition } from './routeDefinitions';

const sharedParams: Partial<RouteDefinition> = {
  exact: true,
  requiresAuth: true,
  requiresDiscoveryKey: CloudDiscoveryKey.featurestoreApiUrl,
  requiresEnvCondition: (env) => env.featureStoreEnabled,
};

export const FEATURESTORE_ROUTE_DEFINITIONS: readonly RouteDefinition[] = [
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_ROOT,
    render: () => <FeaturestoreDashboard />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_PROJECTS,
    render: () => <FeaturestoreProjects />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_MY_PROJECTS,
    render: () => <FeaturestoreProjects />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_PROJECT_DETAILS,
    render: () => <FeaturestoreProjectDetails />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_FEATURE_SET_DETAILS,
    render: () => <FeaturestoreFeatureSetDetails />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_FEATURE_SET_VERSION,
    render: () => <FeaturestoreFeatureSetDetails />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_PENDING_REVIEWS_DETAILS,
    render: () => <FeaturestoreFeatureSetDetails title={ContentsTitle.pendingReviews} />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_PENDING_FEATURE_SET_DETAILS,
    render: () => <FeaturestoreFeatureSetDetails title={ContentsTitle.pendingFeatureSets} />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_FEATURE_SET_FEATURE,
    render: () => <FeaturestoreFeature />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_FEATURE_SETS,
    render: () => <FeaturestoreFeatureSets />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_MY_FEATURE_SETS,
    render: () => <FeaturestoreFeatureSets ownedOnly />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_PENDING_FEATURE_SETS,
    render: () => <FeaturestorePendingReviews title={ContentsTitle.pendingFeatureSets} />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_JOBS,
    render: () => <FeaturestoreJobs />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_PROJECT_PERMISSIONS,
    render: () => <FeaturestoreAccessControl title={ContentsTitle.projectPermissions} />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_FEATURE_SETS_PERMISSIONS,
    render: () => <FeaturestoreAccessControl title={ContentsTitle.featureSetPermissions} />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_PENDING_REVIEWS,
    render: () => <FeaturestorePendingReviews title={ContentsTitle.pendingReviews} />,
  },
  {
    ...sharedParams,
    path: RoutePaths.FEATURESTORE_SEARCH_RESULTS,
    render: () => <FeaturestoreSearchResults />,
  },
];
